import React from 'react'

import { getCookieValue, track } from '../utils'

class Trackable extends React.Component {
    componentDidMount() {
        const { page } = this.props
        if (!window.userLanded) {
            const params = {
                page,
                ab_group: getCookieValue('ab_group'),
                // locale: i18n.lng()
            }

            track('User landed', params, () => {
                window.userLanded = true
                window.ab_group = getCookieValue('ab_group')
            })
        }

        // track page open as well, regardless of the initial landing
        track('Page opened', {
            page,
            // locale: i18n.lng()
        })
    }

    render() {
        const { children, className } = this.props
        return <main className={`content ${className}`}>{children}</main>
    }
}

export default Trackable



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/containers/Trackable.jsx